/* @flow */

import * as React from 'react';
import './mfa-header.module.css';

type Props = {
    children?: React.Node,
    as: string,
};

MfaHeader.defaultProps = {
    as: 'div',
};

export function MfaHeader({children, as: Tag}: Props) {
    return <Tag styleName='mfa-header'>{children}</Tag>;
}
